export const SOCIAL_MEDIA_URL = {
	FACEBOOK: 'www.facebook.com/',
	TWITTER: 'www.twitter.com/',
	INSTAGRAM: 'www.instagram.com/',
	LINKEDIN: 'www.linkedin.com/',
	TIKTOK: 'www.tiktok.com/',
};

export const BLINK_DETAILS = {
	BLINK_URL: 'https://www.blink.mortgage/app/signup/p',
	LABEL: 'Blink+ Link',
};

export const SECTION = {
	ABOUT: {
		TITLE: 'About',
		DESCRIPTION:
			'Include an ‘about’ description that will appear in your MortgageMatchup.com profile listing. To view your profile settings,',
	},
	BLINK: {
		TITLE: 'Blink+',
		DESCRIPTION:
			'Add your Blink+ details to include them on your marketing materials.',
	},
	COMPANY_BRAND: {
		TITLE: 'Company Brand',
		DESCRIPTION: 'Include your logo to build brand awareness and recognition.',
	},
	PERSONAL_DETAILS: {
		TITLE: 'Personal Details',
		DESCRIPTION: 'Include your contact information.',
	},
	PROFILE_PHOTO: {
		TITLE: 'Profile Photo',
		DESCRIPTION:
			'Upload a photo of yourself that you can add to your marketing materials.',
	},
	SOCIAL_MEDIA: {
		TITLE: 'Social Media',
		DESCRIPTION:
			'Add your social media accounts to include them on your marketing materials. To connect your social accounts,',
	},
};

export const SOCIAL_MEDIA_DETAILS = {
	FACEBOOK: {
		name: 'FaceBook',
		label: 'Facebook',
		type: 'text',
		placeholder: 'www.facebook.com/jondoe',
		pattern: '^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,6}$',
		permissionName: 'EditAPersonalFacebook',
	},
	LINKEDIN: {
		name: 'LinkedIn',
		label: 'LinkedIn',
		placeholder: 'www.linkedin.com/jondoe',
		pattern: '^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,6}$',
		permissionName: 'EditAPersonalLinkedin',
	},
	TWITTER: {
		name: 'Twitter',
		label: 'X (Formerly Twitter)',
		placeholder: 'www.twitter.com/jondoe',
		pattern: '^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,6}$',
		permissionName: 'EditAPersonalTwitter',
	},
	INSTAGRAM: {
		name: 'Instagram',
		label: 'Instagram',
		placeholder: 'www.instagram.com/jondoe',
		pattern: '^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,6}$',
		permissionName: 'EditAPersonalInstagram',
	},
	TIKTOK: {
		name: 'TikTok',
		label: 'TikTok',
		placeholder: 'www.tiktok.com/jondoe',
		pattern: '^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,6}$',
		permissionName: 'EditAPersonalTikTok',
	},
};

export const SOCIAL_MEDIA_DETAILS_COMPANY = {
	twitter: {
		name: 'Twitter',
		label: 'X (Formerly Twitter)',
		type: 'text',
		placeholder: 'www.twitter.com/janedoemortgagecompany',
		permissionName: 'EditACompanyTwitter',
		required: false,
		maxLength: 250,
	},
	facebook: {
		name: 'FaceBook',
		label: 'Facebook',
		type: 'text',
		placeholder: 'www.facebook.com/janedoemortgagecompany',
		permissionName: 'EditACompanyFacebook',
		required: false,
		maxLength: 250,
	},
	linkedin: {
		name: 'LinkedIn',
		label: 'LinkedIn',
		type: 'text',
		placeholder: 'www.linkedin.com/janedoemortgagecompany',
		permissionName: 'EditACompanyLinkedin',
		required: false,
		maxLength: 250,
	},
	instagram: {
		name: 'Instagram',
		label: 'Instagram',
		type: 'text',
		placeholder: 'www.instagram.com/janedoemortgagecompany',
		permissionName: 'EditACompanyInstagram',
		required: false,
		maxLength: 250,
	},
	tikTok: {
		name: 'TikTok',
		label: 'TikTok',
		type: 'text',
		placeholder: 'www.tiktok.com/janedoemortgagecompany',
		pattern: '^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,6}$',
		permissionName: 'EditACompanyTikTok',
		required: false,
		maxLength: 250,
	},
	googleMyBusiness: {
		name: 'GoogleMyBusiness',
		label: 'Google My Business',
		type: 'text',
		placeholder: 'g.page/r/ABcDEF2LMg/review',
		permissionName: 'EditACompanyGoogleMyBusiness',
		required: false,
		maxLength: 250,
	},
};

export const FONT_OPTIONS_ARRAY = [
	'',
	'Crimson Text',
	'Heebo',
	'Lato',
	'Merriweather',
	'Montserrat',
	'Open Sans',
	'Playfair Display',
	'Poppins',
	'Rasa',
	'Roboto',
	'Roboto Slab',
	'Source Sans Pro',
	'Source Serif Pro',
];

export const PHONE_MASKS = {
	PHONE_NUMBER_MASK: [
		/[1-9]/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	],
	PHONE_NUMBER_EXTENSION_MASK: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/],
};

export const SPECIAL_CHARACTER_MASK = /[^a-zA-Z 0-9 -]+/g;

export const BRAND_ENTITY = {
	HeaderFontFamily: {
		name: 'HeaderFontFamily',
		value: '',
	},
	Color1: {
		name: 'Color1',
		value: '',
	},
	Color2: {
		name: 'Color2',
		value: '',
	},
	Color3: {
		name: 'Color3',
		value: '',
	},
};

export const SOCIAL_MEDIA_DETAILS_ENTITY = {
	FaceBook: '',
	Twitter: '',
	Instagram: '',
	LinkedIn: '',
	TikTok: '',
};

export const REVIEW_ME = {
	ENABLED: {
		name: 'ReviewMe',
		isOptedIn: true,
		isAutoScheduled: true,
		parameters: {},
		recipientNotifications: [
			{
				recipientType: 'Borrower',
				notifications: [{ notificationType: 'Email', activeInd: true }],
			},
			{
				recipientType: 'Broker',
				notifications: [
					{ notificationType: 'Text', activeInd: false },
					{ notificationType: 'Email', activeInd: true },
				],
			},
		],
		emailTemplateId: 'Review-001',
	},
	DISABLED: {
		name: 'ReviewMe',
		isOptedIn: false,
		isAutoScheduled: false,
		parameters: {},
		recipientNotifications: [
			{
				recipientType: 'Borrower',
				notifications: [{ notificationType: 'Email', activeInd: false }],
			},
			{
				recipientType: 'Broker',
				notifications: [
					{ notificationType: 'Text', activeInd: false },
					{ notificationType: 'Email', activeInd: false },
				],
			},
		],
		emailTemplateId: 'Review-001',
	},
};

export const FALLBACK_ERROR_TYPES = {
	GET_SETTINGS_ERROR: 'GET_SETTINGS_ERROR',
	SAVE_SETTINGS_ERROR: 'SAVE_SETTINGS_ERROR',
};
